<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">待跟进线索</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-select style="width: 160px" allowClear @change="lyhandleChange" placeholder="数据来源" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option) in sourcelist" :key="option.ussid" :value="option.ussid">
                        {{option.title}}
                    </a-select-option>
                </a-select>

                <!-- 标签 -->
                <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="线索状态" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option) in statuslist" :key="option.isvalid" :value="option.isvalid">
                        {{option.title}}
                    </a-select-option>
                </a-select>

                <a-button type="primary" @click="moreTel">快拨</a-button>

                <a-button type="danger" @click="delusers" >删除数据</a-button>

            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    placeholder="关键字（名称/手机）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                   
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="usxsid" :scroll="{x: 1300}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'cluedetail',query: {id:record.usxsid}}" >
                        {{ text }}
                    </router-link>

                    <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.usxsid,record.telephone,record.aid)">
                        <a-icon type="phone" theme="filled" /> 
                        <span v-if="pwdtype==1" style="margin-left:3px">{{text}}</span> 
                        <span v-if="pwdtype==2" style="margin-left:3px">{{text | topwd}}</span>
                        <span v-if="pwdtype==3" style="margin-left:3px">{{text | tomd5}}</span>
                    </a>
                    <span slot="action" slot-scope="text,record">
                        
                        <a href="javascript:;" @click="tokehu(record.usxsid,record.aid,record.remarks)" ><a-icon type="edit" /> 跟进</a>
                        <a href="javascript:;"  style="margin-left:5px" @click="todetail(record.usxsid,record.aid)"><a-icon type="copy"/> 详情</a>
                    </span>

                    <span slot="address" slot-scope="text,record">
                        {{record.province}}{{record.city}}{{record.area}}{{text}}
                    </span>

                    <span slot="sources" slot-scope="text">
                      <span>{{text}}</span>
                    </span>

                    <span slot="sex" slot-scope="text">
                      <span v-if="text==1">男</span>
                      <span v-if="text==2">女</span>
                    </span>
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 转客户 -->
       <a-modal
        title="线索跟进"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="khhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="线索操作">
                    <a-radio-group name="radioGroup" v-model="cluedetail.isvalid" @change="ontypeChange">
                       
                        <a-radio :value="0">
                        状态跟进
                        </a-radio>
                        <a-radio :value="2">
                        无效
                        </a-radio>
                         <a-radio :value="1">
                        转客户
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <!-- <a-form-item label="购卡数量" v-if="numshow">
                    <a-input-number v-model="num" :precision="0" max="10" min="1" v-decorator="['购卡数量', { rules: [{ required: true, message: '请输入购卡数量' }] }]" />
                </a-form-item> -->

                <a-form-item label="跟进状态" v-if="numshow1">
                    <a-radio-group name="radioGroup"  @change="onstatusChange">
                        <a-radio :value="item.isvalid" v-for="item in statuslist" :key="item.isvalid">
                        {{item.title}}
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item label="回访时间" v-if="numshow1">
                    <a-date-picker :locale="locale" @change="onhfChange" placeholder="请选择回访时间"/>
                </a-form-item>
                

                
                <a-form-item label="姓名">
                    <a-input v-model="cluedetail.username" placeholder="请输入客户姓名"/>
                </a-form-item>
                <a-form-item label="电话">
                    <a-input v-model="cluedetail.telephone" placeholder="请输入客户电话"/>
                </a-form-item>
                <a-form-item label="地址">
                    <div style="dispaly:flex;justify-content: space-around;">
                        <!-- <a-cascader v-model="cluedetail.dz"  :field-names="{ label: 'name', value: 'name', children: 'area' }" @change="onaddressChange" :options="adddata" placeholder="请选择省、市、区"  /> -->
                        <v-distpicker :province="cluedetail.province" :city="cluedetail.city" :area="cluedetail.area" @selected="onaddressChange"></v-distpicker>
                    </div>
                   
                    <a-input v-model="cluedetail.address" placeholder="请输入详细地址"/>
                </a-form-item>
                <a-form-item label="性别">
                    <a-radio-group name="radioGroup" @change="cluedetail.sexSelectChange">
                        <a-radio :value="1">
                        男
                        </a-radio>
                        <a-radio :value="2">
                        女
                        </a-radio>
                    </a-radio-group>

                </a-form-item>

                <!-- <a-form-item label="出生日期">
                    <a-date-picker :locale="locale" @change="ondateChange" placeholder="请选择出生日期"/>
                </a-form-item> -->
                <a-form-item label="备注">
                    <a-textarea v-model="cluedetail.remarks" placeholder="备注" :rows="4" />
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
    
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import md5 from 'js-md5'
import { Modal } from 'ant-design-vue';
 import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
moment.locale('zh-cn');
import addresslist from '../../../static/address.json'
 import VDistpicker from 'v-distpicker'
 Vue.component('v-distpicker',VDistpicker)
Vue.prototype.$moment = moment
import {formatDate} from '../../utils/formate.js'
const columns = [
    {title: 'ID',dataIndex: 'usxsid',key: 'usxsid',fixed: 'left',width:'100px'},
    {title: '姓名',dataIndex: 'username',key: 'username',scopedSlots: { customRender: 'name' },width:120},
    {title: '电话',dataIndex: 'telephone',key: 'telephone',scopedSlots: { customRender: 'phone' },width:'160px'},
    {title: '状态',dataIndex:'title_isvalid',key: 'title_isvalid',width:100},
    // {title: '地址',dataIndex: 'address',key: 'address',scopedSlots: { customRender: 'address' }},
    {title: '线索来源',dataIndex: 'title_sources',key: 'title_sources',scopedSlots: { customRender: 'sources' },width:120},
    // {title: '性别',dataIndex: 'sex',key: 'sex',scopedSlots: { customRender: 'sex' },width:80},
    // {title: '出生日期',dataIndex: 'birthday',key: 'birthday',scopedSlots: { customRender: 'date' }},
    {title: '数据时间',dataIndex:'addtime',key: 'addtime',scopedSlots: { customRender: 'date' },width:130},
    {title: '跟进时间',dataIndex:'updatetime',key: 'updatetime',scopedSlots: { customRender: 'date' },width:130},

    {title: '备注',dataIndex: 'remarks',key: 'remarks',width:240},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:160},
];

export default {
     filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },
       topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        const adddata = [];
        return{
            locale,
            show:true,
            lyoption:[{id:1,name:"电话"},{id:2,name:"百度"}],
            typeoption:[{id:0,name:"未跟进"},{id:2,name:"无效线索"}],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:{},
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

            editvisible:false,
            numshow:true,
            numshow1:false,
            // gjvisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            sources:"", //来源
            center:"center",

            usxsid:"",
            isvalid:0,

            username:"",
            num:1,
            telephone:"",
            address:"",
            sex:"",
            birthday:"",
            remarks:"",

            aid:"",
            statuslist:"",
            statusid:"",
            revisitdays:"",//回访时间
            sourcelist:"",

            province:"",
            city:"",
            area:"",

            pwdtype:"",
            cluedetail:"",

            selectedRowKeys: [],
            morecallnum:"",
            currentcallnum:0
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    created(){
        //修改的data值为JSON文件中想要的数据
        this.adddata = addresslist;
    },
    mounted(){
        this.fetch()
        this.getstatus()
        this.getsource()
        this.pwdtype=localStorage.getItem('pwdtype')
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
            })()
        };
    },
    methods:{

          // 删除
        delusers(){
            if(this.selectedRowKeys.length==0){
                this.$message.error("请选择数据");
            }{
                var id=this.selectedRowKeys.join(",")
                Modal.confirm({
                    title: '提示',
                    content: '您确定删除吗?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk:() => {
                        this.handok(id)
                    },
                    onCancel() {

                    },
                });
            }
           
        },
        handok(value){
            this.$axios.post('/api/user/deluserxs',{
                usxsids:value
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    // this.disabled=true
                    this.selectedRowKeys=[]
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 多选框
        onSelectChange(selectedRows){
            console.log(selectedRows)
            this.selectedRowKeys = selectedRows;
        },
        // 快拨
        moreTel(){
            if(this.selectedRowKeys.length==0){
                // this.$message.warning("请选择数据"); 
            }else if(this.selectedRowKeys.length>0){
                this.morecallnum=this.selectedRowKeys.length
                this.$message.success("快拨开始"); 
                var num=this.currentcallnum
                if(num+1>this.morecallnum){
                    this.selectedRowKeys=[]
                    this.currentcallnum=0
                    this.$message.warning("快拨结束"); 
                }else{
                    this.$axios.post('/api/user/userxspage',{
                        usxsid:this.selectedRowKeys[num]
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            sendMsg("changesim")
                            // zhihu(res.data.data.telephone)
                            var timer=setTimeout(()=>{
                                this.tokehu(this.selectedRowKeys[num],0)
                                clearTimeout(timer)
                            },2000)
                           
                            this.currentcallnum++

                            this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
                                telephone:res.data.data.telephone
                            },{
                                headers: {
                                    "token":localStorage.getItem('token'),
                                }  
                            }).then((res)=>{
                                if(res.data.code==200){
                                    zhihu(res.data.data.telephone)
                                }else{
                                    this.$message.error(res.data.msg);
                                }
                            })
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                    
                    })
                }
            }
        },
        
        // 详情
        getdetail(){
             this.$axios.post('/api/user/userxspage',{
                usxsid:this.usxsid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                     if(this.cluedetail.isvalid==""){
                        this.cluedetail.isvalid=0
                    }
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        todetail(usxsid,aid){
            this.$router.push({path:'/cluedetail',query:{id:usxsid,aid:aid}});
            // :to="{path:'cluedetail',query: {id:record.usxsid,aid:record.aid}}"
        },
        // 省市区选择
        onaddressChange(value){
            this.province=value[0]
            this.city=value[1]
            this.area=value[2]
        },
        // 线索来源
        getsource(){
            this.$axios.post('/api/user/usersourceslist',{
                pagesize: 30
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data.data
                    this.sourcelist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 回访时间
        onhfChange(date, dateString) {
            // console.log(date, dateString);
            this.revisitdays=moment(dateString).unix()
        },
        // 状态跟进
        onstatusChange(e){
            this.statusid=e.target.value
        },
        getstatus(){
            this.$axios.post('/api/user/userisvalidlist',{
                pagesize: 30,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data.data
                    this.statuslist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 地址
        handleProvinceChange(){

        },
        // 来源筛选
        lyhandleChange(value){
            this.sources=value
            this.fetch()
        },

        // 标签筛选
        typehandleChange(value){
            this.statusid=value
            this.fetch()
        },

        // 号码查询
        handleserach(){

        },
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/user/userxslist',{
                pagesize: this.size,
                page:this.currentpage,
                ussid:this.sources,
                isvalid:"",
                search:this.searchtext,
                isgh:3
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },

        // 外呼
        totel(id,phone,aid){
            // console.log(id)
            // this.$axios.get('https://fxbkfluyin.13524.net/call_do.php?usxsid='+id,{
            //     headers: {
            //         "token":localStorage.getItem('token'),
            //     },
            // }).then((res)=>{
            //     if(res.data.code==100){
            //         this.$message.success(res.data.msg); 
            //     }else{
            //         this.$message.warning(res.data.msg); 
            //     }
            // })
            sendMsg("changesim")
            this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
                telephone:phone
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    zhihu(phone)
                }else{
                    this.$message.error(res.data.msg);
                }
            })
            // zhihu(phone)
            this.tokehu(id,aid)
        },
        handleCancel(){
            this.editvisible=false
            this.moreTel()
            // this.gjvisible=false
        },
        // 转客户
        tokehu(id,aid){
            this.editvisible=true
            this.usxsid=id
            this.getdetail()
            this.aid=aid
            // this.remarks=remarks

        },
        khhandleOk(){
            this.$axios.post('/api/user/edituserxs',{
                usxsid:this.usxsid,
                aid:this.aid,
                csid:1,
                province:this.cluedetail.province,
                city:this.cluedetail.city,
                area:this.cluedetail.area,
                isvalid:this.statusid,
                username:this.cluedetail.username,
                num:this.num,
                telephone:this.cluedetail.telephone,
                address:this.cluedetail.address,
                sex:this.cluedetail.sex,
                birthday:this.birthday,
                remarks:this.cluedetail.remarks,
                isuser:this.cluedetail.isvalid,
                revisitdays:this.revisitdays
                
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.isvalid=0
                    this.revisitdays=""
                    this.fetch()
                    this.moreTel()
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        // 跟进
        // toedit(id){
        //     this.gjvisible=true
        // },
        // gjhandleOk(){

        // },
        // 表单
        sexSelectChange(e){
            this.sex=e.target.value
        },
        ondateChange(date, dateString) {
            // console.log(date, dateString);
            this.birthday=moment(dateString).unix()
        },
        ontypeChange(e) {
            console.log("e.target.value="+e.target.value)
            this.cluedetail.isvalid=e.target.value
            if( e.target.value==1||e.target.value==2){
                this.numshow=true
                this.numshow1=false
            }else if( e.target.value==0){
                this.numshow=false
                this.numshow1=true
            }
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/cluefollow.vue